module.exports = __webpack_public_path__ + "img/skilled-communicator.242ba015.svg";